"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSendBoxTextBoxStyle;

function createSendBoxTextBoxStyle(_ref) {
  var primaryFont = _ref.primaryFont,
      sendBoxBackground = _ref.sendBoxBackground,
      sendBoxDisabledTextColor = _ref.sendBoxDisabledTextColor,
      sendBoxPlaceholderColor = _ref.sendBoxPlaceholderColor,
      sendBoxTextColor = _ref.sendBoxTextColor,
      subtle = _ref.subtle;
  return {
    alignItems: 'center',
    fontFamily: primaryFont,
    '& > input': {
      backgroundColor: sendBoxBackground,
      border: 0,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      height: '100%',
      outline: 0,
      padding: 0,
      '&:not(:disabled)': {
        color: sendBoxTextColor
      },
      '&:disabled': {
        color: sendBoxDisabledTextColor || subtle
      },
      '&::placeholder': {
        color: sendBoxPlaceholderColor || subtle
      }
    }
  };
}